import React from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import styles from './NewInApp.module.scss';
import Button from '../../../../Components/Button/Button';
import NetteApiClient from '../../../../Services/NetteApiClient';

export interface NewInAppData {
	theme: Theme;
	iconUrl?: string;
	imageUrl?: string;
	title: string;
	description: string;
	list?: { title: string; text: string }[];
	action?: {
		title: string;
		type: string;
	};
}

interface Props {
	data: NewInAppData;
	onClose: () => void;
}

const NewInApp: React.FC<Props> = ({ data, onClose }) => {
	const handleClickAction = () => {
		onClose();
		if (!data.action) return;
		if (data.action.type === 'redirectReservationSystem') {
			NetteApiClient.get('/reservation-system');
		}
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				{data.iconUrl && (
					<div className={styles.iconWrapper}>
						<img src={data.iconUrl} alt='newsIcon' />
					</div>
				)}
				<div className={styles.title}>{data.title}</div>
				<div className={styles.description}>{data.description}</div>
			</div>
			<div className={styles.content}>
				{data.imageUrl && <img src='' alt='newsImage' />}
				{data.list && (
					<div className={styles.list}>
						{data.list.map(item => (
							<div className={styles.item}>
								<div className={styles.icon}>
									<img src='/dist/icons/check-blue.svg' alt='blue check' />
								</div>
								<div>
									<div className={styles.title}>{item.title}</div>
									<div className={styles.text}>{item.text}</div>
								</div>
							</div>
						))}
					</div>
				)}
			</div>
			<div className={styles.footer}>
				{data.action && (
					<Button
						theme={Theme.BLUE}
						title={data.action.title}
						fitContent
						onClick={handleClickAction}
					/>
				)}
			</div>
		</div>
	);
};

export default NewInApp;
